<template>
  <div class="container-fluid">
    <div class="row justify-content-center">
      <div class="col-xl-8 col-lg-8 col-md-12 col-12 text-right pb-3">
        <button class="btn btn-primary btn-sm mr-2" @click="fnDownloadQuote()">
          Download quote <b-spinner small v-if="is_downloading"></b-spinner>
        </button>
        <appModalQuoteEmailOptions
          v-if="quoteType != 'maturing' && leadSource != 'RDL'"
          :propsData="propsData"
          :quoteType="quoteType"
          class="d-inline mr-2"
        ></appModalQuoteEmailOptions>
        <b-button
          v-if="quoteType != 'maturing' && leadSource != 'RDL'"
          type="submit"
          variant="primary"
          class="btn-sm"
          @click.prevent="fnEditQuote()"
          >Back to Quote</b-button
        >
      </div>

      <div class="col-xl-8 col-lg-8 col-md-10 col-12" id="print-aria">
        <div id="printMe">
          <div class="iq-card p-5 bgc-light">
            <div class="" id="qQuotePage1">
              <div id="newTable0">
                <div class="w-50">
                  <img
                    src="../../assets/images/vehicle-solutions-logo-type2.png"
                  />
                </div>
                <div class="w-50 text-right">
                  <p class="text-primary mb-0">
                    Estimate Number <span v-if="quoteType == 'leads'">L-</span>
                    <span v-else></span>{{ objQuoteCalculation.quoteId }}
                  </p>
                  <p class="text-primary mb-0">
                    Provided on
                    {{ objQuoteCalculation.created_at | dateConvertDDMMYYYY }}
                  </p>
                </div>
              </div>
              <div
                class="row bgc-primary-light p-2 sectionTable0 mt-2"
                v-if="objQuoteCalculation"
              >
                <div class="col-lg-12 col-md-12 col-12">
                  <h3 class="text-primary fw-600">
                    Your Novated Lease Estimate
                  </h3>
                  <p class="text-primary mb-0">
                    Prepared for {{ objQuoteCalculation.clientFullName }} -
                    {{ objQuoteCalculation.employerName }} - Annual Gross Salary
                    - ${{ objQuoteCalculation.grossAnnualSalary | with-decimal}}
                  </p>
                </div>
              </div>
              <div class="row mt-2">
                <div class="col-lg-12 col-md-12 col-12 p-0">
                  <div>
                    <h4 class="mb-0 fw-500 pt1000 pb1000">
                      Leasing & Vehicle details
                    </h4>
                    <div id="newTable1">
                      <table>
                        <tbody v-if="objQuoteCalculation">
                          <tr class="top-line">
                            <th style="width: 25%">Vehicle</th>
                            <th style="width: 40%">
                              {{ objQuoteCalculation.vehicleBasicDetail }}
                            </th>
                            <th></th>
                          </tr>
                          <tr>
                            <td>Accessories</td>
                            <td>{{ objQuoteCalculation.accessories }}</td>
                            <td></td>
                          </tr>
                          <tr>
                            <td>Budgeted Annual KM’s</td>
                            <td>
                              {{ objQuoteCalculation.annualKms | with-decimal }}
                              kms
                            </td>
                            <td></td>
                          </tr>
                          <tr>
                            <td>
                              Vehicle Cost
                              <span class="fs-700 fw-700">Exc. GST</span>
                            </td>
                            <td>
                              $
                              {{
                                Number(objQuoteCalculation.totalDriveAwayCost) -
                                Number(objQuoteCalculation.gstOnAsset) | with-decimal
                              }}
                            </td>
                            <td>
                              <span class="fs-700 fw-700"
                                >(You save ${{ objQuoteCalculation.gstOnAsset }}
                                in GST)
                              </span>
                            </td>
                          </tr>
                          <tr>
                            <td>FBT Base Cost of Vehicle</td>
                            <td>
                              $
                              {{ objQuoteCalculation.FBTBaseValue | with-decimal}}
                            </td>
                            <td>
                              <span class="fs-700 fw-700"
                                >(Drive away price minus on road costs)
                              </span>
                            </td>
                          </tr>
                          <tr>
                            <td>Lease Term in Months</td>
                            <td>{{ objQuoteCalculation.leaseTerm }} Months</td>
                            <td>
                              <span class="fs-700 fw-700"
                                >(2 Months Deferred -
                                {{ Number(objQuoteCalculation.leaseTerm) - 2 }}
                                Payments)</span
                              >
                            </td>
                          </tr>
                          <tr>
                            <td>
                              Residual Value
                              <span class="fs-700 fw-700">Inc. GST</span>
                            </td>
                            <td>
                              $
                              {{ objQuoteCalculation.residualValueInclusiveGST | with-decimal}}
                            </td>
                            <td></td>
                          </tr>
                          <tr class="bot-line">
                            <td>Percentage Business Use</td>
                            <td>
                              <span
                                v-if="
                                  objQuoteCalculation.vehicleCategoryId == 11
                                "
                                >0%</span
                              >
                              <span v-else
                                >{{
                                  objQuoteCalculation.businessUsePercentage
                                }}%</span
                              >
                            </td>
                            <td>
                              <span
                                v-if="
                                  objQuoteCalculation.vehicleCategoryId == 11
                                "
                                class="fs-700 fw-700"
                                >(FBT Exemption Vehicle)</span
                              >
                              <span v-else class="fs-700 fw-700"
                                >({{
                                  100 -
                                  Number(
                                    objQuoteCalculation.businessUsePercentage
                                  )
                                }}% Private Use for FBT calculations)</span
                              >
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-lg-12 col-md-12 col-12 p-0">
                  <div style="padding-top: 1rem">
                    <h4 class="mb-0 fw-500 pt1000 pb1000">
                      Benefits of your Novated Lease
                    </h4>
                    <p class="">
                      Using a Novated Lease you don’t pay GST on the car and
                      your employer allows you to pay for your finance, fuel,
                      tyres, scheduled services, registration and insurance
                      renewals before tax. This reduces the amount of tax you
                      pay, leaving more in your pocket.
                    </p>
                  </div>
                </div>
              </div>

              <div class="row" id="page2">
                <div class="col-lg-12 col-md-12 col-12 p-0">
                  <div>
                    <h4 class="mb-0 fw-500 pt1000 pb1000">
                      How does my Novated Lease work?
                    </h4>
                  </div>
                </div>
                <div class="col-lg-12 col-md-12 col-12 p-0">
                  <div id="newTable2">
                    <table>
                      <thead>
                        <tr class="top-line">
                          <th>Lease and Running Costs</th>
                          <th class="txt-right">
                            {{ objQuoteCalculation.payPeriod }} Inc GST
                          </th>
                          <th class="txt-right">
                            Annual Running Cost Budgets Inc GST
                          </th>
                        </tr>
                      </thead>
                      <tbody v-if="objQuoteCalculation">
                        <tr>
                          <td>
                            Lease Cost
                            <span class="fs-700 fw-700"
                              >(2 months deferred)</span
                            >
                          </td>
                          <td class="txt-right">
                            $
                            {{ objQuoteCalculation.finance/Number(objQuoteCalculation.payPeriodInUnits) | with-decimal }}
                          </td>
                          <td class="txt-right">
                            $ {{ objQuoteCalculation.finance | with-decimal }}
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <span
                              v-if="objQuoteCalculation.vehicleCategoryId == 11"
                              >Fuel/Electricity Budget</span
                            ><span v-else>Fuel budget</span>
                          </td>
                          <td class="txt-right">
                            $
                            {{ objQuoteCalculation.fuelCost/Number(objQuoteCalculation.payPeriodInUnits) | with-decimal }}
                          </td>
                          <td class="txt-right">
                            $ {{ objQuoteCalculation.fuelCost | with-decimal }}
                          </td>
                        </tr>
                        <tr>
                          <td>Insurance renewal</td>
                          <td class="txt-right">
                            $
                            {{ Number(objQuoteCalculation.comprehensiveInsurancePremium)/Number(objQuoteCalculation.payPeriodInUnits) | with-decimal }}
                          </td>
                          <td class="txt-right">
                            $
                            {{ Number(objQuoteCalculation.comprehensiveInsurancePremium) | with-decimal }}
                          </td>
                        </tr>
                        <tr>
                          <td>Registration renewal</td>
                          <td class="txt-right">
                            $
                            {{ Number(objQuoteCalculation.registration)/Number(objQuoteCalculation.payPeriodInUnits) | with-decimal }}
                          </td>
                          <td class="txt-right">
                            $
                            {{ Number(objQuoteCalculation.registration) | with-decimal }}
                          </td>
                        </tr>
                        <tr>
                          <td>Tyre budget</td>
                          <td class="txt-right">
                            $
                            {{ objQuoteCalculation.tyresCostPerAnual/Number(objQuoteCalculation.payPeriodInUnits) | with-decimal }}
                          </td>
                          <td class="txt-right">
                            $
                            {{ objQuoteCalculation.tyresCostPerAnual | with-decimal }}
                          </td>
                        </tr>
                        <tr>
                          <td>Servicing budget</td>
                          <td class="txt-right">
                            $
                            {{ objQuoteCalculation.maintenanceCostPerAnual/Number(objQuoteCalculation.payPeriodInUnits) | with-decimal }}
                          </td>
                          <td class="txt-right">
                            $
                            {{ objQuoteCalculation.maintenanceCostPerAnual | with-decimal }}
                          </td>
                        </tr>
                        <tr>
                          <td>Administration fee</td>
                          <td class="txt-right">
                            $
                            {{ Number(objQuoteCalculation.salaryPackagingProviderFee)/Number(objQuoteCalculation.payPeriodInUnits) | with-decimal }}
                          </td>
                          <td class="txt-right">
                            $
                            {{ Number(objQuoteCalculation.salaryPackagingProviderFee) | with-decimal }}
                          </td>
                        </tr>
                        <tr>
                          <td class="text-primary fw-700">
                            Total {{ objQuoteCalculation.payPeriod }} cost inc
                            GST
                          </td>
                          <td class="text-primary fw-700 txt-right">
                            $
                            {{ Number(objQuoteCalculation.totalAnnualBudget)/Number(objQuoteCalculation.payPeriodInUnits) | with-decimal }}
                          </td>
                          <td></td>
                        </tr>
                        <tr>
                          <td class="fw-700" style="color: #3948e8">
                            Minus your GST Savings
                          </td>
                          <td class="fw-700 txt-right" style="color: #3948e8">
                            $
                            {{ Number(objQuoteCalculation.GSTSavings)/Number(objQuoteCalculation.payPeriodInUnits) | with-decimal }}
                          </td>
                          <td
                            class="txt-right"
                            style="color: #3948e8; text-align: left"
                          >
                            <span class="fs-700 fw-700"
                              >($
                              {{ (Number(objQuoteCalculation.GSTSavings) * Number(objQuoteCalculation.leaseTerm)/12) | with-decimal }}
                              over the lease term)</span
                            >
                          </td>
                        </tr>
                        <tr>
                          <td class="fw-700" style="color: #3948e8">
                            Minus your Income Tax Savings
                          </td>
                          <td class="fw-700 txt-right" style="color: #3948e8">
                            $
                            {{ Number(objQuoteCalculation.incomeTaxSavings)/Number(objQuoteCalculation.payPeriodInUnits) | with-decimal }}
                          </td>
                          <td
                            class="txt-right"
                            style="color: #3948e8; text-align: left"
                          >
                            <span class="fs-700 fw-700"
                              >($
                              {{ (Number(objQuoteCalculation.incomeTaxSavings) * Number(objQuoteCalculation.leaseTerm)/12)| with-decimal }}
                              over the lease term)</span
                            >
                          </td>
                        </tr>
                        <tr class="bg-primary bot-line">
                          <td class="fw-700" style="color: #fff">
                            Net out of pocket cost to your
                            {{ objQuoteCalculation.payPeriod }} pay.
                          </td>
                          <td class="txt-right fw-700" style="color: #fff">
                            $
                            {{ (Number(objQuoteCalculation.costToFortnightlyTakeHomePay)* -1)/Number(objQuoteCalculation.payPeriodInUnits) | with-decimal }}
                          </td>
                          <td></td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-12 pl-0">
                  <h4 class="fw-900 fs-3500 text-primary">
                    $
                    {{ (Number(objQuoteCalculation.costToFortnightlyTakeHomePay)* -1)/Number(objQuoteCalculation.payPeriodInUnits) | with-decimal }}
                  </h4>
                  <p
                    class="fw-400 fs-1600 mb-0 m-t1400"
                    v-if="objQuoteCalculation && objQuoteCalculation.payPeriod"
                  >
                    This is the cost to your
                    {{ objQuoteCalculation.payPeriod.toLowerCase() }} take home
                    pay.
                  </p>
                  <p class="mb300 m-t700">
                    Includes finance, fuel, scheduled services, tyres, insurance
                    and registration renewals.
                  </p>
                </div>

                <div class="col-12 pl-0">
                  <p class="fs-2000 fw-900 mb-0 text-primary">
                    ${{
                      Number(objQuoteCalculation.gstOnAsset) +
                      ((Number(objQuoteCalculation.GSTSavings) *
                        Number(objQuoteCalculation.leaseTerm)) /
                        12) +
                      ((Number(objQuoteCalculation.incomeTaxSavings) *
                        Number(objQuoteCalculation.leaseTerm)) /
                        12) | with-decimal
                    }}
                  </p>
                  <p class="fw-400 m-t700 fs-1600">
                    Income tax & GST Savings over the lease term.
                  </p>
                  <p class="fw-700 m-t1800 fs-1000">
                    You have saved
                    <span style="color: #3948e8"
                      >${{ (Number(objQuoteCalculation.incomeTaxSavings) * Number(objQuoteCalculation.leaseTerm)/12)| with-decimal }}</span
                    >
                    in income tax,
                    <span style="color: #3948e8"
                      >${{ (Number(objQuoteCalculation.GSTSavings) * Number(objQuoteCalculation.leaseTerm)/12) | with-decimal }}</span
                    >
                    in GST on the running cost and
                    <span style="color: #3948e8"
                      >${{ objQuoteCalculation.gstOnAsset | with-decimal }}</span
                    >
                    in GST on the vehicle.
                  </p>
                </div>
              </div>
            </div>

            <div class="" id="qQuotePage2">
              <div class="row">
                <div class="col-lg-12 col-md-12 col-12 p-0 mt-3">
                  <div>
                    <h4 class="mb-0 fw-500 pt1000 pb1000 text-primary">
                      How will this vehicle affect your take home pay?
                    </h4>
                  </div>
                </div>
                <div class="col-lg-12 col-md-12 col-12 p-0">
                  <div id="newTable3">
                    <table>
                      <thead>
                        <tr class="top-line">
                          <th>Breakdown</th>
                          <th class="txt-right">Current Pay</th>
                          <th class="txt-right">Adding This Vehicle</th>
                          <th class="txt-right"></th>
                        </tr>
                      </thead>
                      <tbody v-if="objQuoteCalculation">
                        <tr>
                          <td>{{ objQuoteCalculation.payPeriod }} Salary</td>
                          <td class="txt-right">
                            $
                            {{ Number(objQuoteCalculation.fortnightlySalary)/Number(objQuoteCalculation.payPeriodInUnits) | with-decimal }}
                          </td>
                          <td class="txt-right">
                            $
                            {{ Number(objQuoteCalculation.netGrossTaxableSalaryWithoutPackaged)/Number(objQuoteCalculation.payPeriodInUnits) | with-decimal }}
                          </td>
                          <td class="txt-right"></td>
                        </tr>
                        <tr>
                          <td>Pre Tax Vehicle Deduction</td>
                          <td class="txt-right">$ {{ 0  | with-decimal }}</td>
                          <td class="txt-right">
                            $
                            {{ Number(objQuoteCalculation.preTaxVehicleDeduction)/Number(objQuoteCalculation.payPeriodInUnits) | with-decimal }}
                          </td>
                          <td class="txt-left">
                            <span class="fs-700 fw-700"
                              >(Pre Tax Deduction)</span
                            >
                          </td>
                        </tr>
                        <tr>
                          <td>
                            Taxable {{ objQuoteCalculation.payPeriod }} Salary
                          </td>
                          <td class="txt-right">
                            $
                            {{ Number(objQuoteCalculation.fortnightlySalary)/Number(objQuoteCalculation.payPeriodInUnits) | with-decimal }}
                          </td>
                          <td class="txt-right">
                            $
                            {{ ((Number(objQuoteCalculation.fortnightlySalary) - Number(objQuoteCalculation.preTaxVehicleDeduction))/Number(objQuoteCalculation.payPeriodInUnits)) | with-decimal }}
                          </td>
                          <td class="txt-right"></td>
                        </tr>
                        <tr>
                          <td>Tax & Medicare Levy</td>
                          <td class="txt-right">
                            $
                            {{ Number(objQuoteCalculation.totalTaxPayableIncMedicareWithoutPackaged)/Number(objQuoteCalculation.payPeriodInUnits) | with-decimal }}
                          </td>
                          <td class="txt-right">
                            $
                            {{ Number(objQuoteCalculation.totalTaxPayableIncMedicarePackaged)/Number(objQuoteCalculation.payPeriodInUnits) | with-decimal }}
                          </td>
                          <td class="txt-right"></td>
                        </tr>

                        <tr>
                          <td>
                            Post Tax Deduction
                            <span class="fs-700 fw-700"
                              >(FBT Contribution)</span
                            >
                          </td>
                          <td class="txt-right">$ {{ 0 | with-decimal }}</td>
                          <td class="txt-right">
                            $
                            {{ Number(objQuoteCalculation.fBTContributionAfterTax)/Number(objQuoteCalculation.payPeriodInUnits) | with-decimal }}
                          </td>
                          <td class="txt-left">
                            <span class="fs-700 fw-700"
                              >(Post Tax Deduction)*</span
                            >
                          </td>
                        </tr>
                        <tr>
                          <td>Total Net Take Home Pay</td>
                          <td class="txt-right">
                            $
                            {{ (Number(objQuoteCalculation.totalNetTakeHomePayWithCurrentPay))/Number(objQuoteCalculation.payPeriodInUnits) | with-decimal }}
                          </td>
                          <td class="txt-right">
                            $
                            {{ (Number(objQuoteCalculation.totalNetTakeHomePayWithAddingThisVehicle))/Number(objQuoteCalculation.payPeriodInUnits) | with-decimal }}
                          </td>
                          <td class="txt-right"></td>
                        </tr>

                        <tr class="bot-line">
                          <td class="fw-600 text-light bg-primary">
                            Cost of this vehicle to
                            {{ objQuoteCalculation.payPeriod }} take-home pay
                          </td>
                          <td
                            class="fw-600 text-light bg-primary txt-right"
                          ></td>
                          <td class="fw-600 text-light bg-primary txt-right">
                            $
                            {{ (Number(objQuoteCalculation.costToFortnightlyTakeHomePay)* -1)/Number(objQuoteCalculation.payPeriodInUnits) | with-decimal }}
                          </td>
                          <td class="bg-primary"></td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              <div class="row mt-3">
                <div class="col-lg-12 col-md-12 col-12 p-0">
                  <div>
                    <h4 class="mb-0 fw-500 pt1000 text-primary">
                      Use your tax and GST savings to offset your car's running
                      costs.
                    </h4>
                    <p class="">
                      Every car needs fuel, tyres, scheduled services,
                      registration, and insurance to run, and usually some form
                      of finance. A Novated lease allows you to pay for these
                      costs before tax. The income tax and GST savings assist in
                      offsetting the cost of running the car. This makes Novated
                      Leasing the most affordable and convenient way to finance
                      your next car
                    </p>
                  </div>

                  <div class="mb-5">
                    <h4 class="mb-0 fw-500 pt1000 text-primary">
                      What happens at the end of the lease?
                    </h4>
                    <p class="">At the end of the lease you have 3 options;</p>

                    <div class="end-of-lease">
                      <div class="container-type-1">
                        <div class="centered text-center lease-img-1">
                          <p class="color-vsa-purple mb-0 fw-700 title">
                            Upgrade your car
                          </p>
                          <p class="text-info mb-0 subtitle">
                            Sell, or trade in and <br />upgrade to a new car.
                          </p>
                        </div>
                      </div>

                      <div class="container-type-1">
                        <div class="centered lease-img-2">
                          <p class="color-vsa-purple mb-0 fw-700 title">
                            Keep your car.
                          </p>
                          <p class="text-info mb-0 subtitle">
                            Payout the residual <br />payment and own the car.
                          </p>
                        </div>
                      </div>

                      <div class="container-type-1">
                        <div class="centered lease-img-3">
                          <p class="color-vsa-purple mb-0 fw-700 title">
                            Re-lease and keep saving.
                          </p>
                          <p class="text-info mb-0 subtitle">
                            Re-lease the residual <br />value and keep saving
                            tax.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div id="benefits-summary">
                    <h4 class="mb-0 fw-900 pt1000 text-primary">
                      Novated Lease Benefits Summary
                    </h4>

                    <ul class="pl-3 mt-2">
                      <li>
                        You
                        <span
                          >save an estimated $
                          {{ objQuoteCalculation.gstOnAsset  | with-decimal }}
                        </span>
                        in GST off the car's drive away cost.
                      </li>
                      <li>
                        You
                        <span v-if="objQuoteCalculation">
                          save $
                          {{ ((Number(objQuoteCalculation.GSTSavings) + Number(objQuoteCalculation.incomeTaxSavings)) * Number(objQuoteCalculation.leaseTerm)/12) | with-decimal}}
                        </span>
                        in Income tax and GST over the life of the lease.
                      </li>
                      <li>
                        You will
                        <span> never need to worry</span>
                        about paying the vehicle registration and insurance
                        again,
                        <span> it's covered!</span>
                      </li>
                      <li>
                        <span>NO</span>
                        more service bills, or that big tyre change;
                        <span> it's covered!</span>
                      </li>
                      <li>
                        <span>You get a fuel card,</span>
                        and the bill gets paid.
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            <div class="" id="qQuotePage3">
              <div
                class="row bgc-primary-light p-2 sectionTable0 mt-5 mb-5"
                v-if="objQuoteCalculation"
              >
                <div class="col-lg-12 col-md-12 col-12">
                  <h4 class="text-primary fw-600">
                    Why is a Novated Lease the best way to finance your next
                    car?
                  </h4>
                </div>
              </div>

              <div class="finance-your-next-car">
                <div class="img-section">
                  <img
                    src="https://vehicle-solutions.s3.ap-southeast-2.amazonaws.com/vsa-images/keep_car_image.png"
                  />
                </div>
                <div class="text-section">
                  <h5 class="fw-700 text-primary">
                    Tax Savings and Convenience
                  </h5>
                  <p>
                    Novated leasing lets you pay your car expenses before tax.
                    This means you pay less tax and have more money in each pay.
                    The other big benefit in Novated Leasing is the convenience.
                    All of your vehicle expenses are covered.
                    <span class="fw-700"
                      >When your registration is due; it's covered! When your
                      insurance renewal is due; its covered! Need a service or a
                      new set of tyres? That's already budgeted for and
                      covered!</span
                    >
                    Simply enjoy the drive knowing your car expenses are covered
                    and you're saving thousands in GST and tax.
                  </p>
                </div>
              </div>

              <div class="printing finance-your-next-car mt-5">
                <div class="img-section">
                  <img
                    src="https://vehicle-solutions.s3.ap-southeast-2.amazonaws.com/vsa-images/save_tax_image.png"
                  />
                </div>
                <div class="text-section">
                  <h5 class="fw-700 text-primary">
                    The Tax Savings offset the interest paid on the finance.
                  </h5>
                  <p>
                    A vast majority of Australians finance their new cars in
                    some form; Personal Loan, Commercial Loan....or a Novated
                    Lease. By financing your next car on a personal loan or home
                    loan you have no way of offsetting the amount of interest
                    you pay. With a Novated Lease your tax savings (shown at the
                    bottom of the 1st page) offset the interest you pay. This
                    can make a Novated Lease the cheapest form of financing and
                    it's the reason why large employers and all government
                    departments have been using Novated Leasing as their
                    employee benefit for over 20 years.
                  </p>
                </div>
              </div>

              <div class="printing row mt-5">
                <div class="col-lg-12 col-md-12 col-12">
                  <h1 class="fw-700 mb-0 text-info">
                    What's the process from here?
                  </h1>
                  <p>
                    Super easy, application, approval, document signing,
                    settlement, and
                    <span class="color-vsa-purple fw-700">delivery</span>
                  </p>
                </div>
                <div class="col-lg-12 col-md-12 col-12">
                  <div class="process-from-here">
                    <div class="container-type-1">
                      <div class="centered text-center process-from-img-1">
                        <p class="color-primary mb-0 fw-700 title">
                          Get a pre-approval
                        </p>
                        <p class="text-info mb-0 subtitle">
                          5 minute Application Payslip & Drivers Licence.
                        </p>
                        <p class="color-primary mb-0 subtitle">
                          Same day approval
                        </p>
                      </div>
                    </div>

                    <div class="container-type-1">
                      <div class="centered text-center process-from-img-2">
                        <p class="color-primary mb-0 fw-700 title">
                          Documents & Settlement
                        </p>
                        <p class="text-info mb-0 subtitle">
                          We produce all the <br />documents for signing.
                          <br />Then settle the finance.
                        </p>
                      </div>
                    </div>

                    <div class="container-type-1">
                      <div class="centered text-center process-from-img-3">
                        <p class="color-vsa-purple mb-0 fw-700 title">
                          Delivery Your Car
                        </p>
                        <p class="text-info mb-0 subtitle">
                          As soon as your finance <br />settles you can take
                          <br />delivery of your car!
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="">
                <p>
                  Thank you for this opportunity to present the most affordable
                  way to purchase and run your next vehicle.
                </p>
                <p>
                  Please feel free to contact me anytime, if you have any
                  questions or would like to proceed to a pre-approval.
                </p>

                <p class="mt500 mb-0 font-weight-bold">
                  {{ objQuoteCalculation.createdUserName }}
                </p>
                <p class="mb-0 font-weight-bold">
                  Mobile {{ objQuoteCalculation.createdUserMobNumber }}
                </p>
                <p class="mb-0 font-weight-bold">
                  Email {{ objQuoteCalculation.createdUserEmail }}
                </p>
                <p class="mb-0 font-weight-bold">
                  {{ objQuoteCalculation.dealerName }}
                </p>
              </div>

              <div id="disclaimer">
                <p class="title">Disclaimer</p>
                <p class="text mb-1">
                  Whilst all efforts have been made to provide the most accurate
                  results possible, these figures are based on the information
                  you have provided and should only be used as an estimate, they
                  do not take into account any existing payroll deductions or
                  salary sacrifice you have in place. The example includes
                  scheduled servicing, tyres, registration, lease payments,
                  fuel, and an estimate for comprehensive insurance. If
                  requested by you the example may include Motor Equity and/or
                  Lease Protection Insurance policies. Prior to signing any
                  documents you will be provided with a copy of all the
                  paperwork including an estimate, lease terms and conditions
                  and a copy of insurance policies, Product Disclosure
                  Statements and the company's Financial Services Guide. All
                  standard insurance PDS's and our company's FSG is available on
                  our website to download and read in order for you to make an
                  informed decision. Please also refer to our privacy policy
                  that outline the information we collect, why we collect it and
                  how we use and store this information
                </p>
                <p class="fs-700">
                  Vehicle Solutions Australia Pty Ltd | Australian Credit
                  Licence 469600
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style>
.sectionTable0 {
  border-radius: 10px;
  background-color: #ebf4ff;
}

#newTable0 img {
  max-width: 60%;
  max-height: auto;
}
#newTable0 {
  display: flex;
  flex-wrap: nowrap;
}

#newTable1 table {
  border-collapse: collapse;
  width: 90%;
  background-color: #ebf4ff;
  border-radius: 15px;
}
#newTable1 table th {
  padding: 0.2rem;
  padding-left: 1rem;
  padding-right: 1rem;
  vertical-align: top;
  border-top: 0px solid #dee2e6;
  color: #4f5962;
  font-weight: 400;
}
#newTable1 table td {
  padding: 0.2rem;
  padding-left: 1rem;
  padding-right: 1rem;
  vertical-align: top;
  border-top: 0.5px solid #dee2e6;
  color: #4f5962;
}
#newTable1 table tr.top-line th {
  padding-top: 0.5rem;
}
#newTable1 table tr.bot-line td {
  padding-bottom: 0.5rem;
}

#newTable2 table {
  border-collapse: collapse;
  width: 100%;
  background-color: #ebf4ff;
  border-radius: 15px;
}
#newTable2 table th {
  padding: 0.2rem;
  padding-left: 1rem;
  padding-right: 1rem;
  vertical-align: top;
  border-top: 0px solid #dee2e6;
  color: #4f5962;
}
#newTable2 table td {
  padding: 0.2rem;
  padding-left: 1rem;
  padding-right: 1rem;
  vertical-align: top;
  border-top: 0.5px solid #dee2e6;
  color: #4f5962;
}
#newTable2 table tr.top-line th {
  padding-top: 0.5rem;
}
#newTable2 table tr.bot-line td {
  padding-bottom: 0.5rem;
}

#newTable3 table {
  border-collapse: collapse;
  width: 100%;
  background-color: #ebf4ff;
  border-radius: 15px;
}
#newTable3 table th {
  padding: 0.2rem;
  padding-left: 1rem;
  padding-right: 1rem;
  vertical-align: top;
  border-top: 0px solid #dee2e6;
  color: #4f5962;
}
#newTable3 table td {
  padding: 0.2rem;
  padding-left: 1rem;
  padding-right: 1rem;
  vertical-align: top;
  border-top: 0.5px solid #dee2e6;
  color: #4f5962;
}
#newTable3 table tr.top-line th {
  padding-top: 0.5rem;
}
#newTable3 table tr.bot-line td {
  padding-bottom: 0.5rem;
}
#benefits-summary {
  background-color: #ebf4ff;
  padding: 1rem;
}
#benefits-summary ul li span {
  font-style: italic;
  font-weight: 900 !important;
  color: black;
  font-size: 16px;
}
#benefits-summary ul {
  list-style-type: disc !important;
}

/*
* finance-your-next-car
*
*/
.finance-your-next-car {
  display: flex;
  justify-content: space-between;
}

.finance-your-next-car .img-section {
  width: 20%;
}
.finance-your-next-car .img-section img {
  position: relative;
  width: 85%;
}
.finance-your-next-car .text-section {
  width: 78%;
}

/*
* end-of-lease
*/
.container-type-1 {
  float: left;
  width: 33.33%;
  padding: 10px;
  text-align: center;
}

.container-type-1 .subtitle {
  line-height: 15px;
}

/* Clear floats after the columns */
.end-of-lease:after {
  content: '';
  display: table;
  clear: both;
}

/* Responsive layout - makes the three columns stack on top of each other instead of next to each other */
@media screen and (max-width: 600px) {
  .container-type-1 {
    width: 100%;
  }

  .container-type-1 .lease-img-1 {
    background-image: url('https://vehicle-solutions.s3.ap-southeast-2.amazonaws.com/vsa-images/upgrade_your_car.png');
    background-position: center;
    background-size: 250px 250px !important;
    height: 250px !important;
    padding-top: 5px !important;
  }

  .container-type-1 .lease-img-2 {
    background-image: url('https://vehicle-solutions.s3.ap-southeast-2.amazonaws.com/vsa-images/keep_your_car.png');
    background-repeat: no-repeat;
    background-position: center;
    background-size: 250px 250px !important;
    height: 250px !important;
    padding-top: 5px !important;
  }
  .container-type-1 .lease-img-3 {
    background-image: url('https://vehicle-solutions.s3.ap-southeast-2.amazonaws.com/vsa-images/keep_saving.png');
    background-repeat: no-repeat;
    background-position: center;
    background-size: 250px 250px !important;
    height: 250px !important;
    padding-top: 5px !important;
  }

  .container-type-1 .process-from-img-1 {
    background-image: url('https://vehicle-solutions.s3.ap-southeast-2.amazonaws.com/vsa-images/pre_approval.png');
    background-repeat: no-repeat;
    background-position: center;
    background-size: 250px 250px !important;
    height: 250px !important;
    padding-top: 5px !important;
  }
  .container-type-1 .process-from-img-2 {
    background-image: url('https://vehicle-solutions.s3.ap-southeast-2.amazonaws.com/vsa-images/doccument.png');
    background-repeat: no-repeat;
    background-position: center;
    background-size: 250px 250px !important;
    height: 250px !important;
    padding-top: 5px !important;
  }
  .container-type-1 .process-from-img-3 {
    background-image: url('https://vehicle-solutions.s3.ap-southeast-2.amazonaws.com/vsa-images/delivery.png');
    background-repeat: no-repeat;
    background-position: center;
    background-size: 250px 250px !important;
    height: 250px !important;
    padding-top: 5px !important;
  }
}

.container-type-1 .lease-img-1 {
  background-image: url('https://vehicle-solutions.s3.ap-southeast-2.amazonaws.com/vsa-images/upgrade_your_car.png');
  background-repeat: no-repeat;
  /* background-attachment: fixed; */
  background-position: center;
  background-size: 300px 300px;
  height: 300px;
  padding-top: 20px;
}
.container-type-1 .lease-img-2 {
  background-image: url('https://vehicle-solutions.s3.ap-southeast-2.amazonaws.com/vsa-images/keep_your_car.png');
  background-repeat: no-repeat;
  /* background-attachment: fixed; */
  background-position: center;
  background-size: 300px 300px;
  height: 300px;
  padding-top: 20px;
}
.container-type-1 .lease-img-3 {
  background-image: url('https://vehicle-solutions.s3.ap-southeast-2.amazonaws.com/vsa-images/keep_saving.png');
  background-repeat: no-repeat;
  /* background-attachment: fixed; */
  background-position: center;
  background-size: 300px 300px;
  height: 300px;
  padding-top: 20px;
}

/*
* process-from-here
*/
/* Clear floats after the columns */
.process-from-here:after {
  content: '';
  display: table;
  clear: both;
}

.container-type-1 .process-from-img-1 {
  background-image: url('https://vehicle-solutions.s3.ap-southeast-2.amazonaws.com/vsa-images/pre_approval.png');
  background-repeat: no-repeat;
  /* background-attachment: fixed; */
  background-position: center;
  background-size: 300px 300px;
  height: 300px;
  padding-top: 20px;
}
.container-type-1 .process-from-img-2 {
  background-image: url('https://vehicle-solutions.s3.ap-southeast-2.amazonaws.com/vsa-images/doccument.png');
  background-repeat: no-repeat;
  /* background-attachment: fixed; */
  background-position: center;
  background-size: 300px 300px;
  height: 300px;
  padding-top: 20px;
}
.container-type-1 .process-from-img-3 {
  background-image: url('https://vehicle-solutions.s3.ap-southeast-2.amazonaws.com/vsa-images/delivery.png');
  background-repeat: no-repeat;
  /* background-attachment: fixed; */
  background-position: center;
  background-size: 300px 300px;
  height: 300px;
  padding-top: 20px;
}

/*
* Disclaimer
*/
#disclaimer {
  margin-top: 1.5rem;
}
#disclaimer .title {
  font-weight: 700;
  margin-bottom: 0.2rem;
}
#disclaimer .title,
#disclaimer .text {
  font-size: 0.8rem;
  line-height: 14px;
}

.txt-left {
  text-align: left;
}
.txt-right {
  text-align: right;
}
.fw-600 {
  font-weight: 600;
}
.fw-700 {
  font-weight: 700;
}
.fs-700 {
  font-size: 0.7rem;
}
.bg-info {
  background-color: var(--iq-info);
}
.text-primary {
  color: #38afef;
}

.mb-0 {
  margin-bottom: 0;
}
</style>
<script>
import store from '../../store/modules/base.module'
import * as quoteService from '../../services/quote.service'
import * as messageService from '../../services/message.service'
import * as quoteCalculationService from '../../services/quoteCalculation.service'
import * as authService from '../../services/auth.service'
import appModalQuoteEmailOptions from '../../components/quote/ModalQuoteEmailOptions.vue'
export default {
  name: 'quoteViewCom',
  props: {
    quoteType: {
      type: String,
      required: true,
      default: 'quote'
    },
    propsData: {
      type: Object,
      required: true
    },
    leadSource: {
      type: String,
      required: false
    }
  },
  components: {
    appModalQuoteEmailOptions
  },

  data() {
    return {
      quoteId: this.$route.params.quoteId,
      userData: {},
      is_spinActive: false,
      is_downloading: false,
      error: ''
    }
  },
  computed: {
    objQuoteCalculation() {
      return quoteCalculationService.calculation1(
        this.quoteType,
        this.quoteId,
        this.propsData
      )
    }
  },
  methods: {
    /**
     * Download temp quote.
     */
    fnDownloadQuote: async function () {
      try {
        this.$emit('callSingleQuote')
        this.is_downloading = true

        // Delete temp files in the storage
        await quoteService.deleteTempQuote()

        const response = await quoteService.createQuoteDownload({
          objQuoteCalculation: this.objQuoteCalculation
        })
        this.is_downloading = false

        const { file_path_with_name: file_path_with_name } = response.data

        // Download or open new tab pdf file
        window.open(
          `${store.state.serverPath}/` + file_path_with_name,
          '_blank'
        )

        messageService.fnSweetAlertSuccessToast(
          'Quote downloaded',
          'Successfully'
        )
      } catch (error) {
        switch (error.response.status) {
          case 422:
            this.errors = error.response.data.errors
            break
          case 500:
            messageService.fnSweetAlertErrorToast(
              'Quote downloaded',
              error.response.data.message
            )
            break
          default:
            messageService.fnSweetAlertErrorToast(
              'Quote downloaded',
              'Something wrong'
            )
            break
        }
        this.is_downloading = false
      }
    },

    /**
     * quoteType:quote|leads
     */
    fnEditQuote() {
      if (
        this.quoteType == 'quote' &&
        (this.userData.role_id == 1 || this.userData.role_id == 2)
      ) {
        this.$router.push({
          name: 'admin.quoteEdit',
          params: { quoteId: this.quoteId }
        })
      }

      if (this.userData.role_id == 3 && this.quoteType == 'quote') {
        this.$router.push({
          name: 'bdm.quoteEdit',
          params: { quoteId: this.quoteId }
        })
      }

      if (this.userData.role_id == 4 && this.quoteType == 'quote') {
        this.$router.push({
          name: 'dealer.quoteEdit',
          params: { quoteId: this.quoteId }
        })
      }

      if (
        (this.userData.role_id == 1 || this.userData.role_id == 2) &&
        this.quoteType == 'leads'
      ) {
        this.$router.push({
          name: 'admin.leadsEdit',
          params: { quoteId: this.quoteId }
        })
      }

      if (this.userData.role_id == 3 && this.quoteType == 'leads') {
        this.$router.push({
          name: 'bdm.leadsEdit',
          params: { quoteId: this.quoteId }
        })
      }

      if (
        this.userData.role_id == 4 &&
        this.quoteType == 'leads' &&
        (this.leadSource == 'RPL' || this.leadSource == 'RCL')
      ) {
        this.$router.push({
          name: 'dealer.leadsEdit',
          params: { quoteId: this.quoteId }
        })
      }

      if (
        this.userData.role_id == 4 &&
        this.quoteType == 'leads' &&
        this.leadSource == 'RDL'
      ) {
        this.$router.push({
          name: 'dealer.referLeadsEdit',
          params: { quoteId: this.quoteId }
        })
      }
    }
  },
  created() {
    this.userData = authService.getUserFromToken()
  }
}
</script>
